import React, { useEffect, useRef } from "react";
import { hasPerfFlag } from "@/lib/perf-flags";

// ─── Glow del cursor (referencia línea 1063 + _onMouse 2073 + cursorStyle 3815) ───
export default function CursorGlow() {
  const ref = useRef<HTMLDivElement>(null);
  // diagnóstico: ?noglow=1 (fixed + mix-blend-mode cuesta al compositor aunque
  // en táctil nunca llegue a verse, porque solo lo mueve mousemove).
  const off = hasPerfFlag("noglow");
  useEffect(() => {
    if (off) return;
    const onMouse = (e: MouseEvent) => {
      const el = ref.current;
      if (el) {
        el.style.opacity = "1";
        el.style.transform = "translate(" + e.clientX + "px, " + e.clientY + "px)";
      }
    };
    window.addEventListener("mousemove", onMouse, { passive: true });
    return () => window.removeEventListener("mousemove", onMouse);
  }, [off]);
  if (off) return null;
  return (
    <div
      ref={ref}
      style={{
        position: "fixed", top: 0, left: 0, width: 156, height: 156, marginLeft: -78, marginTop: -78,
        borderRadius: "50%", pointerEvents: "none", zIndex: 45, opacity: 0, mixBlendMode: "multiply",
        background: "radial-gradient(closest-side, rgba(11,136,196,0.30), rgba(11,136,196,0.12) 46%, transparent 72%)",
        transition: "opacity .4s ease", willChange: "transform",
      }}
    />
  );
}
